module.exports = __webpack_public_path__ + "files/e6f0d388b98c210c382de5281fe474c3.png";